// @flow

import React from 'react';
import Logo from 'assets/icons/logo_.svg';
import styles from './styles.module.scss';

const Spinner = () => (
  <div className={styles.wrap}>
    <img className={styles.spinner} src={Logo} alt="loading.." />
  </div>
);

export default Spinner;
